import { render, staticRenderFns } from "./ReturnChange.vue?vue&type=template&id=c5c87f28&scoped=true"
import script from "./ReturnChange.vue?vue&type=script&lang=js"
export * from "./ReturnChange.vue?vue&type=script&lang=js"
import style0 from "./ReturnChange.vue?vue&type=style&index=0&id=c5c87f28&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c87f28",
  null
  
)

export default component.exports